import { stringifyUrl } from "query-string";

import { routes } from "@libs/routing/routes.ts";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

import { useAppointmentLink } from "./useAppointmentLink.ts";

export const useAppointmentsLinks = (): NavLink[] => {
  return [
    useAppointmentLink(),
    { name: "Appointment book", path: routes.calendarEvents.basePath },
    {
      name: "Appointment reminders",
      key: "eventReminders",
      url: stringifyUrl({
        url: routes.calendarEvents.basePath.pattern,
        query: {
          [routes.calendarEvents.queryKeys.calendarPage]: "eventReminders"
        }
      }),
      permissions: routes.calendarEvents.basePath.permissions
    },
    {
      name: "Waiting list",
      key: "waitingList",
      url: stringifyUrl({
        url: routes.calendarEvents.basePath.pattern,
        query: {
          [routes.calendarEvents.queryKeys.calendarPage]: "waitingList"
        }
      }),
      permissions: routes.calendarEvents.basePath.permissions
    }
  ];
};
